import React from "react"
import { Button, Spinner } from "react-bootstrap";
import { FaArrowRotateRight } from "react-icons/fa6";
import ToolTip from "../Tooltip/Tooltip";
import i18next from "i18next";

type Props = {
  isLoading: boolean;
  actionName: string;
  action?: () => void;
  tooltip?: string;
}

const ReloadAction: React.FC<Props> = ({ isLoading, actionName, action, tooltip }) => {
  return (
    <Button
      id={`reload-action-${actionName}`}
      disabled={isLoading}
      onClick={() => action?.()}
    >
      {isLoading ? (
        <Spinner animation="border" size="sm" />
      ) : (
        <><span className="me-2">{i18next.t('reload')}</span> <FaArrowRotateRight /> </>
      )}
      <ToolTip
        anchorId={`reload-action-${actionName}`}
        content={tooltip}
        className="default"
      />
    </Button>
  )
}


export default ReloadAction;
